import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import watch from './attrs/watch'
import ListHeader from '@/components/ListHeader/Index'
import Autocomplete from "vuejs-auto-complete";

export default {
  name: 'PagarmeChargebacks',
  computed,
  data,
  methods,
  mounted,
  watch,
  components: {
    ListHeader,
    Autocomplete,
  }
}
